import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import CompanyInfoTab from '@/pages/admin/company/AdminCompanyInfoTab'
import HolidayTab from '@/pages/admin/company/AdminHolidayTab'

type TabKey = 'info' | 'holiday'

const TABS: { key: TabKey; label: string }[] = [
  { key: 'info', label: '기관정보관리' },
  { key: 'holiday', label: '휴무일관리' },
]

export default function AdminCompanyManagement() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab') as TabKey | null
  const [activeTab, setActiveTab] = useState<TabKey>(tabParam ?? 'info')

  const handleTabChange = (tab: TabKey) => {
    setActiveTab(tab)
    setSearchParams({ tab })
  }

  return (
    <div className="bg-[#f5f2f0] min-h-screen p-8">
      <div className="max-w-[1200px] mx-auto">

        {/* Header */}
        <div className="mb-6">
          <h1 className="text-[22px] font-extrabold text-[#2a1f1a] mb-1">기관/휴무일 관리</h1>
          <p className="text-[13px] text-gray-400">
            {new Date().toLocaleDateString('ko-KR', {
              year: 'numeric', month: 'long', day: 'numeric', weekday: 'long',
            })}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mb-5 bg-white rounded-xl border border-[#e8e0dc] p-1 w-fit shadow-[0_2px_8px_rgba(136,114,103,0.06)]">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabChange(tab.key)}
              className={`px-5 py-2 rounded-lg text-[13px] font-semibold transition-all cursor-pointer border-none ${
                activeTab === tab.key
                  ? 'bg-[#887267] text-white shadow-sm'
                  : 'bg-transparent text-[#5a3d32] hover:bg-[#f5f2f0]'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {activeTab === 'info' && <CompanyInfoTab />}
        {activeTab === 'holiday' && <HolidayTab />}

      </div>
    </div>
  )
}
